import { FC } from "react";
import { copy } from "shared/assets";
import { IInfoBlockItem } from "shared/types";

import { useScrollToHashOnFirstRender } from "shared/utils";

import { InfoBlockItemsOverview } from "./containers";

const {
  bandAssets: { sidemenu: contactsCopy },
} = copy;

export const ContactsOverviewPage: FC = () => {
  useScrollToHashOnFirstRender();

  return <InfoBlockItemsOverview type={IInfoBlockItem.contact} title={contactsCopy.contacts} />;
};
